module.exports = __webpack_public_path__ + "static/shopping.0a2dae83.png";